module.exports = __webpack_public_path__ + "static/vplogo-4dfa53fa01c7eb63bfd0ef9180f1c438.svg";